import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { ConfigurationPlanningService } from './configuration-planning.service';
import { ConfigurationPlanningTab1Part } from './tabs/tab-1/configuration-planning-tab-1.part';
import { ConfigurationPlanningTab2Part } from './tabs/tab-2/configuration-planning-tab-2.part';
import { ConfigurationPlanningViewsPart } from './views/planning-views.part';

@Component({
	selector: 'configuration-planning-page',
	standalone: true,
	imports: [
		ConfigurationPlanningTab1Part,
		ConfigurationPlanningTab2Part,
		ConfigurationPlanningViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget, DroplistWidget, ToolbarWidget,],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './configuration-planning.page.html',
})
export class ConfigurationPlanningPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	constructor(public pageService: ConfigurationPlanningService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}